export const traineeList = "TRAINEE_LIST";
export const traineeLetter = "TRAINEE_LETTER";
export const traineeDocuments = "TRAINEE_DOCUMENTS";
export const traineeCourses = "TRAINEE_COURSES";
export const traineeAssessment="TRAINEE_ASSESSMENT";
export const traineeCertificates = "TRAINEE_CERTIFICATES";